import React, { useState, useEffect } from 'react';
import Employee from '../../../forms/employee';
import Role from '../../../forms/role';
import restApiClient from '../../../services/restApiClient';
import CrudTable from '../../../components/crudTable';
import FilterTree from '../../../helpers/filterTree';
import { Container, UserBadge, LockPassword, Close, Restore } from './styles';
import ShowPassDialog from '../../../components/showPassDialog';

function EmployeeList({ history }) {
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState({ count: 0, values: [] });
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [orderBy, setOrderby] = useState({ name: 'asc' });
  const [searchBy, setSearchBy] = useState('');
  const [password, setPassword] = useState('');
  const [resetConfirmationId, setResetConfirmationId] = useState(-1);

  const columns = Employee.tableSchema;

  useEffect(() => {
    restApiClient.employee
      .getAll(
        rowsPerPage,
        page * rowsPerPage,
        searchBy
          ? new FilterTree()
              .like('name', searchBy)
              .or()
              .like('login', searchBy)
              .or()
              .like('unit.name', searchBy)
              .toString()
          : null,
        orderBy
      )
      .then((e) => {
        setRows(e.data);
      });
  }, [rowsPerPage, page, orderBy, searchBy]);

  return (
    <Container>
      <CrudTable
        title={'Cadastro de Funcionários'}
        modelActions={Employee.actions}
        columns={columns}
        rows={rows}
        page={page}
        setPage={(page) => setPage(page)}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={(rowsPerPage) => setRowsPerPage(rowsPerPage)}
        onOrderByChange={(orderBy) => setOrderby(orderBy)}
        orderBy={orderBy}
        setOrderBy={(value) => setOrderby(value)}
        searchBy={searchBy}
        setSearchBy={(value) => setSearchBy(value)}
        customConfirmations={[
          {
            selector: (id) => id === resetConfirmationId,
            content: <span>Você tem certeza que deseja alterar senha?</span>,
            onSuccess: (employeeId) => {
              restApiClient.employee
                .resetPassword(employeeId)
                .then((result) => {
                  setPassword(result.data.passwordChanged);
                  setResetConfirmationId(-1);
                });
            },
            onCancel: () => setResetConfirmationId(-1),
          },
        ]}
        actions={{
          add: { onClick: () => history.push('/employee/create') },
          update: {
            onClick: (employeeId) =>
              history.push(`/employee/update/${employeeId}`),
            selector: (row) => !row?.deletedAt,
          },
          link: {
            icon: <UserBadge />,
            title: 'Vincular Cargo',
            onClick: (employeeId) =>
              history.push(`/employee/${employeeId}/role/link`),
            allowedActions: [
              [
                Role.actions.getAll,
                Employee.actions.findById,
                Employee.actions.updateRoles,
              ],
            ],
            selector: (row) => !row?.deletedAt,
          },
          resetPassword: {
            icon: <LockPassword />,
            title: 'Alterar Senha',
            onClick: (employeeId) => {
              setResetConfirmationId(employeeId);
            },
            allowedActions: [Employee.actions.resetPassword],
            selector: (row) => !row?.deletedAt,
          },
          customDelete: {
            icon: <Close />,
            onClick: (employeeId, index) => {
              restApiClient.employee.delete(employeeId).then(() => {
                const result = { ...rows };
                const restored = result.values.find(
                  (x) => x.userId === employeeId
                );
                restored.deletedAt = 'datanova';
                setRows(result);
              });
            },
            title: 'Desativar',
            allowedActions: [Employee.actions.delete],
            selector: (row) => !row?.deletedAt,
          },
          restore: {
            icon: <Restore />,
            onClick: (dentistId, index) => {
              restApiClient.employee.restore(dentistId).then(() => {
                const result = { ...rows };
                const restored = result.values.find(
                  (x) => x.userId === dentistId
                );
                restored.deletedAt = null;
                setRows(result);
              });
            },
            title: 'Ativar',
            allowedActions: [Employee.actions.restore],
            selector: (row) => row?.deletedAt,
          },
        }}
      />

      <ShowPassDialog
        onClose={() => {
          setPassword('');
        }}
        password={password}
        open={!!password}
      />
    </Container>
  );
}

export default EmployeeList;
